import React from 'react'

import WaterUsageComponent from '../Components/WaterUsage/WaterUsageComponent'
import { useVisibleDevices } from '@data/device/device'

const WaterUsage: React.FC = () => {
  const devices = useVisibleDevices()

  return (
    <div>
      <WaterUsageComponent devices={devices} />
    </div>
  )
}

export default WaterUsage
